export default "__VITE_ASSET__D$GiKVBr__"